'use client';

import isPropValid from '@emotion/is-prop-valid';
import { Provider } from '@m/components-ui/provider';
import { antTheme } from '@m/theme/antTheme';
import theme from '@m/theme/theme';
import { ConfigProvider } from 'antd';
import { ThemeProvider, StyleSheetManager } from 'styled-components';
// This implements the default behavior from styled-components v5
export function shouldForwardProp(propName: string, target: any) {
  if (typeof target === 'string') {
    return isPropValid(propName);
  }
  return true;
}
export interface ProvidersProps {
  children?: React.ReactNode;
  defaultTheme?: 'light' | 'dark';
}

export default function SharedProviders({ children, defaultTheme = 'light' }: ProvidersProps) {
  return (
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
      <Provider defaultTheme={defaultTheme}>
        <ConfigProvider theme={antTheme}>
          <ThemeProvider theme={theme}>{children}</ThemeProvider>
        </ConfigProvider>
      </Provider>
    </StyleSheetManager>
  );
}
